export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7800.6b295f18.jpg";